module.exports = __webpack_public_path__ + "static/media/enabledVehicleIcon.31ea4cf0.svg";